import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { IAmenidad, IEventoCalendario } from '../../models/reservas';
import { useReservas } from '../../hooks/useReservas';
import { Disponibilidad } from './Disponibilidad';
import { SeleccionAmenidad } from './SeleccionAmenidad';
import { RevisionReserva } from './RevisionReserva';
import { CustomModal } from '../../components/Modal';
import { useNavigate } from 'react-router-dom';

export const Reservas = () => {
  const navigate = useNavigate();
  const [paso, setPaso] = useState(1);
  const [loadingEventos, setLoadingEventos] = useState(false);
  const [amenidad, setAmenidad] = useState<number>(-1);
  const [amenidadesList, setAmenidadesList] = useState<IAmenidad[]>([]);
  const [eventos, setEventos] = useState<IEventoCalendario[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [modalMessage, setModalMessage] = useState<string>('');
  const [isError, setIsError] = useState<boolean>(false);
  const [idReserva, setIdReserva] = useState<number>(-1);
  const { getListAmenidades, getEventos, addReserva, getListadoErroresReserva } = useReservas();

  const clearAllStates = () => {
    setEventos([]);
    setAmenidad(-1);
  }

  const notifyModal = (message: string, error: boolean) => {
    setModalMessage(message);
    setIsError(error);
    setOpenModal(true);
  }

  const handleCloseModal = () => {
    setOpenModal(false);
    if (!isError) {
      clearAllStates();
      setPaso(1);
      navigate('/home');
    }
  };

  const pasos = [
    () => (
      <SeleccionAmenidad
        nextStep={() => setPaso(2)}
        nextText="Siguiente"
        amenidadesList={amenidadesList}
        setAmenidad={setAmenidad}
        amenidad={amenidad}
      />
    ),
    () => (
      <Disponibilidad
        prevStep={() => setPaso(1)}
        prevText="Anterior"
        nextStep={() => setPaso(3)}
        nextText="Siguiente"
        loadingEventos={loadingEventos}
        setEventos={setEventos}
        eventos={eventos}
        amenidadesList={amenidadesList}
        amenidad={amenidad}
      />
    ),
    () => (
      <RevisionReserva
        prevStep={() => setPaso(2)}
        prevText="Anterior"
        amenidad={amenidad}
        clearAction={clearAllStates}
        amenidadesList={amenidadesList}
        eventos={eventos}
        reservaAction={(evento) => addReserva(evento)}
        nextStep={() => setPaso(1)}
        setReservaError={setIdReserva}
      />
    )
  ];

  useEffect(() => {
    if (idReserva >= 1) {
      getListadoErroresReserva(idReserva)
      .then(listado => {
        const mainObject = listado.reduce((acc, curr) => {
          return ({nota: `${acc?.nota}, ${curr?.nota}`});
        });
        const errores:string = mainObject.nota;
        notifyModal(errores==='Paso todas las validaciones.' ? 'Reserva realizada con exito!' : errores, false);
      })
      .catch((err) => {
        console.error(`[Reservas]: Error = ${JSON.stringify(err)}`);
        if (Object.keys(err).length === 0)
          notifyModal('Reserva realizada con exito!', false);
        else
          notifyModal(`Ha ocurrido un error: ${err?.message}`, true);
      })
    }
  }, [idReserva]);


  

  useEffect(() => {
    setLoadingEventos(true);
    getListAmenidades().then(response => {
      setAmenidadesList(response as IAmenidad[]);
    });
  }, [])

  useEffect(() => {
    getEventos(amenidad).then(response => {
      setEventos(response);
      setLoadingEventos(false);
    });
  }, [amenidad])

  return (
    <Box textAlign="center" display="flex" alignItems="center" width={'100%'} height={'100vh'} flexDirection='column'>
      <Typography variant="h4" component="div" gutterBottom marginY='1em'>
        Reservas
      </Typography>

      <CustomModal
        openState={openModal}
        onCloseHandler={handleCloseModal}
      >
        <Typography variant="h6">
          Reservas
        </Typography>
        <Typography variant="h6" component="div" gutterBottom>
          {modalMessage}
        </Typography>
        <Button color='secondary' variant="outlined" sx={{marginY:2 , width:'50%'}} onClick={handleCloseModal} >
          OK
        </Button>
      </CustomModal>

      {pasos[paso - 1]()}

    </Box>
  )
}